import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { X } from 'lucide-react';

interface PatientLimitIncreaseBlockedModalProps {
  open: boolean;
  onClose: () => void;
}

export const PatientLimitIncreaseBlockedModal: React.FC<PatientLimitIncreaseBlockedModalProps> = ({
  open,
  onClose,
}) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="sm:max-w-md w-full p-0 overflow-hidden">
      <div className="px-6 pt-6 pb-4 relative" style={{ background: 'linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%)' }}>
        <DialogClose className="absolute top-4 right-4 rounded-full w-7 h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
          <X size={16} />
        </DialogClose>
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold" style={{ color: '#1e1b4b' }}>
            Por ahora no hace falta ampliar tu disponibilidad
          </DialogTitle>
        </DialogHeader>
      </div>

      <div className="px-6 pb-2 flex flex-col gap-4">
        <div className="rounded-2xl bg-[#F5F3FF] border border-[#DDD6FE] px-5 py-4">
          <p className="text-sm text-gray-700 leading-relaxed m-0">
            Por el momento, no es necesario que continúes ampliando tu disponibilidad horaria, ya que
            no podemos garantizar nuevas asignaciones en todas las agendas. Si contás con horas libres y
            querés destinarlas a otros proyectos o a tu práctica privada, sentite totalmente libre de
            hacerlo - Agradecemos el compromiso con el que venís trabajando y el interés por seguir
            creciendo dentro del equipo.
          </p>
        </div>
      </div>

      <div className="px-6 py-4 border-t border-gray-100 flex flex-col gap-2 mt-4">
        <button
          type="button"
          className="btn-purple w-full"
          onClick={onClose}
        >
          Entendido
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default PatientLimitIncreaseBlockedModal;
